import { UtensilsCrossed } from "lucide-react";
import { cateringUrl } from "../mock";
import { useT } from "../context/LanguageContext";
import { trackEvent } from "../utils/analytics";

/**
 * Discrete always-visible floating Catering CTA (bottom-right, all pages).
 * Opens the HoneyCart catering ordering site in a new tab.
 */
export default function FloatingCateringCTA() {
  const t = useT();
  return (
    <a
      href={cateringUrl("floating_cta")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Book Catering"
      data-testid="floating-catering-cta"
      onClick={() => trackEvent("catering_click", { source: "floating_cta" })}
      className="fixed z-40 right-5 bottom-[86px] sm:bottom-5 group inline-flex items-center gap-2 bg-granite-dark text-cream pl-3.5 pr-4 py-3 rounded-full text-sm font-semibold shadow-2xl border border-cream/15 hover:bg-brand hover:border-brand hover:-translate-y-0.5 transition-all duration-300"
    >
      <UtensilsCrossed className="w-4 h-4 text-brand-light group-hover:text-cream transition-colors" />
      <span>{t("Book Catering", "Contrata Catering")}</span>
    </a>
  );
}
